import React from 'react';
import styles from './JobseekerProfileEmployerViewBody.module.css';
import { useTranslation } from 'react-i18next';
import AboutMe from './AboutMe';
import OverView from './OverView';
import Education from './Education';
import WorkExperience from './WorkExperience';
import Certifications from './Certifications';
import Portfolio from './Portfolio';
import Skills from './Skills';
import RoleBasedSkills from './RoleBasedSkills';
import WorkProficiency from './WorkProficiency';

function JobseekerProfileEmployerViewBody({ jobseeker, blur, sectionRefs }) {
    const { t } = useTranslation();
    return (
        <div style={{ position: 'relative' }}>
            {/* <div className={styles.container}> */}
            <div className={`${blur && styles.blur} ${styles.container}`} >

                <div className={styles.wrapper}>
                    <div className={styles.aboutMe} style={{ padding: 0 }}>
                        {jobseeker?.description &&
                            <>
                                <AboutMe jobseeker={jobseeker} ref={sectionRefs.aboutMe} />
                                <div className={styles.saperator} >
                                    <div className={styles.leftCorner}></div>
                                    <div className={styles.rightCorner}></div>
                                </div>
                            </>
                        }
                        {jobseeker?.education?.length > 0 &&
                            <>
                                <Education jobseeker={jobseeker} ref={sectionRefs.education} />
                                <div className={styles.saperator} >
                                    <div className={styles.leftCorner}></div>
                                    <div className={styles.rightCorner}></div>
                                </div>
                            </>
                        }
                        {jobseeker?.education?.length > 0 &&
                            <>
                                <WorkExperience jobseeker={jobseeker} ref={sectionRefs.workExperience} />
                                <div className={styles.saperator} >
                                    <div className={styles.leftCorner}></div>
                                    <div className={styles.rightCorner}></div>
                                </div>
                            </>
                        }
                        {jobseeker?.skills?.length > 0 &&
                            <>
                                <Skills jobseeker={jobseeker} ref={sectionRefs.skills} />
                                <div className={styles.saperator} >
                                    <div className={styles.leftCorner}></div>
                                    <div className={styles.rightCorner}></div>
                                </div>
                            </>
                        }
                        {jobseeker?.roleSkills?.length > 0 &&
                            <>
                                <RoleBasedSkills jobseeker={jobseeker} ref={sectionRefs.roleSkills} />
                                <div className={styles.saperator} >
                                    <div className={styles.leftCorner}></div>
                                    <div className={styles.rightCorner}></div>
                                </div>
                            </>
                        }
                        {jobseeker?.certification?.length > 0 &&
                            <>
                                <Certifications jobseeker={jobseeker} ref={sectionRefs.certifications} />
                                <div className={styles.saperator} >
                                    <div className={styles.leftCorner}></div>
                                    <div className={styles.rightCorner}></div>
                                </div>
                            </>
                        }
                        {jobseeker?.portfolio?.length > 0 &&
                            <Portfolio jobseeker={jobseeker} ref={sectionRefs.portfolio} />
                        }
                    </div>
                    <div className={styles.overview}>
                        <OverView jobseeker={jobseeker} ref={sectionRefs.skills} />
                        {/* {
                            jobseeker?.logic_test_result &&
                            <WorkProficiency jobseeker={jobseeker} ref={sectionRefs.workProficiency} />
                        } */}
                    </div>

                </div>
            </div>

            {/* Decorative Circles */}
            <div className={styles.i1}></div>
            <div className={styles.i2}></div>
            <div className={styles.i3}></div>
            <div className={styles.i4}></div>
        </div >
    );
}

export default JobseekerProfileEmployerViewBody;
